import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui';
import TextField from 'material-ui/TextField';
import TextFieldStyles from './TextFieldStyles';

const Input = ({ classes, label, name, value, placeholder, onChange }) => (
  <div className={classes.container}>
    <TextField
      fullWidth
      name={name}
      value={value}
      label={label}
      onChange={onChange}
      placeholder={placeholder}
      InputProps={{
        disableUnderline: true,
        classes: {
          root: classes.textFieldRoot,
          input: classes.textFieldInput,
        },
      }}
      InputLabelProps={{
        shrink: true,
        className: classes.textFieldFormLabel,
      }}
    />
  </div>
);

Input.propTypes = {
  classes: PropTypes.object.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func,
  label: PropTypes.string,
  name: PropTypes.string,
  placeholder: PropTypes.string,
};

export default withStyles(TextFieldStyles)(Input);



// WEBPACK FOOTER //
// ./src/components/textField/TextField.js